import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from 'react-i18next';

// import icon1 from "../../../../../../assets/images/rgpc/section-2/1.svg";
import icon1 from "../../../../../../assets/images/homepage/section-5/gestao-projetos.svg";
import icon2 from "../../../../../../assets/images/quality/section-3/vantagem-competitiva.svg";
import icon3 from "../../../../../../assets/images/development/section-4/implementacao.svg";
import icon4 from "../../../../../../assets/images/quality/section-3/conformidade.svg";
import icon5 from "../../../../../../assets/images/homepage/section-5/gestao-papel-comercial.svg";
import icon6 from "../../../../../../assets/images/homepage/section-5/reserva-salas-reunioes.svg";
import icon7 from "../../../../../../assets/images/quality/section-3/reducao-custos.svg";
import icon8 from "../../../../../../assets/images/rgpc/section-2/5.svg";


const OutsourcingPilar5 = props => (
    <section id="outsourcing-pilar-section5" className="my pt-5 white-bg">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:outsourcingPilar:section-5.title')}</h2>
            {/* Text content */}
            <div className='mb-5'>
                <div className='d-flex align-items-center'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-5.1.title')}</h3>
                </div>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.1.subtitle.1.title')}</h4>
                <p className='mb-3'>
                    <Trans
                        i18nKey="services:outsourcingPilar:section-5.1.subtitle.1.text"
                        components={{
                            br: <br />,
                            statistaServices: <a href="https://www.statista.com/outlook/tmo/it-services/portugal" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                            statistaOutsourcing: <a href="https://www.statista.com/outlook/tmo/it-services/it-outsourcing/portugal" target="_blank" rel="noopener noreferrer" className='light-orange' />
                        }}
                    />
                </p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.1.subtitle.2.title')}</h4>
                <p className='mb-3'>
                    <Trans
                        i18nKey="services:outsourcingPilar:section-5.1.subtitle.2.text"
                        components={{
                            br: <br />,
                            eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                            jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                        }}
                    />
                </p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.1.subtitle.3.title')}</h4>
                <p>
                    <Trans
                        i18nKey="services:outsourcingPilar:section-5.1.subtitle.3.text"
                        components={{
                            br: <br />,
                            pressMedia: <a href="https://www.pressmediaonline.com/news/85746588" target="_blank" rel="noopener noreferrer" className='light-orange' />
                        }}
                    />
                </p>
            </div>
            {/* Text content */}
            <div className='mb-5'>
                <div className='d-flex align-items-center'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-5.2.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingPilar:section-5.2.txt')}</p>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon1} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.2.subtitle.1.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.2.subtitle.1.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon2} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.2.subtitle.2.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.2.subtitle.2.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon3} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.2.subtitle.3.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.2.subtitle.3.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
            </div>
            {/* Text content */}
            <div className='mb-5'>
                <div className='d-flex align-items-center'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-5.3.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingPilar:section-5.3.txt')}</p>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon4} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.3.subtitle.1.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.3.subtitle.1.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon5} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.3.subtitle.2.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.3.subtitle.2.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon6} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.3.subtitle.3.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.3.subtitle.3.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon7} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.3.subtitle.4.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.3.subtitle.4.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    {/* Icon */}
                    <div className='icon-container d-none d-md-block'>
                        <div className="diamond-top-icon">
                            <div className="icon">
                                <img alt={props.alt} src={icon8} />
                            </div>
                        </div>
                    </div>
                    {/* Text */}
                    <div>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.3.subtitle.5.title')}</h4>
                        <p>
                            <Trans
                                i18nKey="services:outsourcingPilar:section-5.3.subtitle.5.text"
                                components={{
                                    br: <br />,
                                    eCommerceNews: <a href="https://ecommercenews.pt/mercado-de-ti-em-portugal-vai-representar-investimento-de-53-mil-milhoes-de-euros-em-2023" target="_blank" rel="noopener noreferrer" className='light-orange' />,
                                    jornalEconomico: <a href="https://jornaleconomico.sapo.pt/noticias/tic-regista-volume-de-negocios-de-16-mil-milhoes-de-euros-mas-ia-reduz-emprego" target="_blank" rel="noopener noreferrer" className='light-orange' />
                                }}
                            />
                        </p>
                    </div>
                </div>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-5.4.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingPilar:section-5.4.txt')}</p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.4.subtitle.1.title')}</h4>
                <p className='mb-3'>
                    <Trans
                        i18nKey="services:outsourcingPilar:section-5.4.subtitle.1.text"
                        components={{
                            br: <br />
                        }}
                    />
                </p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.4.subtitle.2.title')}</h4>
                <p className='mb-3'>
                    <Trans
                        i18nKey="services:outsourcingPilar:section-5.4.subtitle.2.text"
                        components={{
                            br: <br />
                        }}
                    />
                </p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.4.subtitle.3.title')}</h4>
                <p className='mb-3'>
                    <Trans
                        i18nKey="services:outsourcingPilar:section-5.4.subtitle.3.text"
                        components={{
                            br: <br />
                        }}
                    />
                </p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingPilar:section-5.4.subtitle.4.title')}</h4>
                <p className='mb-0'>
                    <Trans
                        i18nKey="services:outsourcingPilar:section-5.4.subtitle.4.text"
                        components={{
                            br: <br />
                        }}
                    />
                </p>
            </div>
        </Container>
    </section>
);


export default OutsourcingPilar5;